import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "customInput", "usedRoomsGroup"];
  static values = { initialValue: String };

  connect() {
    if (!this.initialValueValue) {
      if (this.selectTarget.options.length <= 1) this.showCustomInput();
      return;
    }

    if (this.optionExists(this.initialValueValue)) {
      this.selectTarget.value = this.initialValueValue;
    } else {
      this.showCustomInput();
      this.customInputTarget.value = this.initialValueValue;
    }
  }

  handleSelectChange(event) {
    if (event.target.value === "Custom...") {
      this.showCustomInput();
    } else if (event.target.value) {
      this.hideCustomInput();
    }
  }

  handleCustomKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.handleCustomInput(event);
    }
  }

  handleCustomInput(event) {
    const customValue = event.target.value.trim();

    if (!customValue) {
      this.selectTarget.value = "";
      this.hideCustomInput();
      return;
    }

    if (!this.optionExists(customValue)) {
      this.addRoomOption(customValue);
    }

    this.selectTarget.value = customValue;
    this.hideCustomInput();
  }

  showCustomInput() {
    this.toggleFields(true);
    this.customInputTarget.value = "";
    this.customInputTarget.focus();
  }

  hideCustomInput() {
    this.toggleFields(false);
  }

  toggleFields(showCustom) {
    this.selectTarget.classList.toggle("hidden", showCustom);
    this.selectTarget.toggleAttribute("required", !showCustom);
    this.selectTarget.disabled = showCustom;

    this.customInputTarget.classList.toggle("hidden", !showCustom);
    this.customInputTarget.toggleAttribute("required", showCustom);
    this.customInputTarget.disabled = !showCustom;
  }

  addRoomOption(roomName) {
    const newOption = document.createElement("option");
    newOption.value = roomName;
    newOption.textContent = roomName;

    this.usedRoomsGroupTarget.classList.remove("hidden");

    const existingOptions = Array.from(this.usedRoomsGroupTarget.children);
    const insertIndex = existingOptions.findIndex(
      (opt) => opt.value.localeCompare(roomName) > 0
    );

    if (insertIndex === -1) {
      this.usedRoomsGroupTarget.appendChild(newOption);
    } else {
      this.usedRoomsGroupTarget.insertBefore(
        newOption,
        existingOptions[insertIndex]
      );
    }
  }

  optionExists(value) {
    return Array.from(this.selectTarget.options).some(
      (opt) => opt.value === value
    );
  }
}
